module.exports = __webpack_public_path__ + "img/unmuted.04e90c6.svg";